import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { VehicleSidenavHandleService } from '@/new-transport/_shared/vehicles-sidenav/vehicle-sidenav-handle.service';
import { TransportMapStore } from '@/new-transport/transport-map/_store/transport-map.store';

@Component({
	selector: 'app-vehicle-in-use',
	standalone: true,
	templateUrl: './vehicle-in-use.component.html',
	styleUrl: './vehicle-in-use.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleInUseComponent {
	readonly store = inject(TransportMapStore);

	private readonly vehicleSidenavHandle = inject(VehicleSidenavHandleService);

	toggleSidenav(): void {
		this.vehicleSidenavHandle.toggle();
	}
}
